let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dFrhq")).then(() => parcelRequire('2ghCe'));